<template>
	<AppDialog dialogName="SuggestCredentialsTypeDialog" width="620" :closeTop="'-30'" :closeRight="'-10'">
		<ShareFeatureDialogHeader :service="service" :workflow="workflow" />
		<SuggestCredentialsTypeDialogContent :next="next" @close="close" v-if="workflow" :workflow="workflow" :isFromPublish="isFromPublish" />
	</AppDialog>
</template>

<script>
import AppDialog from '../AppDialog/AppDialog.vue';
import { mapGettersShorthand } from '@/store/utils/mappers';
import { getServiceBySlug } from '@/store/modules/apps/getters';
import AppDialogManagerService from '../AppDialogManager/app-dialog-manager-service';
import ShareFeatureDialogHeader from '@/components/dialogs/ShareFeatureDialog/ShareFeatureDialogHeader.vue';
import SuggestCredentialsTypeDialogContent from '@/components/dialogs/SuggestCredentialsTypeDialog/SuggestCredentialsTypeDialogContent.vue';
export default {
	name: 'SuggestCredentialsTypeDialog',
	components: {
		AppDialog,
		ShareFeatureDialogHeader,
		SuggestCredentialsTypeDialogContent,
	},
	props: {
		next: { type: Function },
		workflow: { type: Object },
		dialogPromiseHandlers: { type: Object },
		isFromPublish: { type: Boolean, default: false },
	},
	computed: {
		...mapGettersShorthand({ getServiceBySlug }),
		contextServiceSlug() {
			return this.workflow.context_service_slug;
		},
		service() {
			return this.contextServiceSlug ? this.getServiceBySlug(this.contextServiceSlug) : null;
		},
	},
	methods: {
		close() {
			this.dialogPromiseHandlers.resolve();
			AppDialogManagerService.closeCurrentDialog();
		},
	},
};
</script>

<style scoped lang="scss"></style>
